import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FoodcourtService } from 'src/app/services/foodcourt.service';

@Component({
  standalone: false,
  selector: 'app-review-remove-flag',
  templateUrl: './review-remove-flag.component.html',
  styleUrls: ['./review-remove-flag.component.scss'],
})
export class ReviewremoveflagComponent implements OnInit {
  @Input() couponId: string;
  @Input() fromDetailsPage: any;
  @Input() fromListPage: any;
  @Input() foodCourtVendorId: any;
  @Input() reviewId: any;

  listCouponIds = [];

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private foodcourtService: FoodcourtService
  ) {
    this.myForm = this.formBuilder.group({
      deletedBy: '',
      userId: ''
    });
  }

  ngOnInit(): void { }

  removeFlagVendor() {
    this.foodcourtService
      .removeFlagBulk(this.reviewId)
      .subscribe((res) => {
        console.log(res);
        if (res.isValid) {
          location.reload();
        }
      });
    this.modal.dismiss();
  }
}
